import { NIL } from 'uuid';
import axios from 'axios';
import {
  QueryStatus, useMutation, useQuery, useQueryClient,
} from 'react-query';
import { getEmptyItem, Item } from '../models/item';

const getItemById = async (id: string) => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}item/${id}`);
  return data;
};
const postItem = async (item: Item) => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  if (item.id !== NIL) {
    await axios.post(`${apiUrl}item/${item.id}`, item);
  } else {
    await axios.post(`${apiUrl}item`, item);
  }
};

interface ItemProps {
  id: string;
  onSuccess?: (data: Item) => void;
}
const useItem = (props: ItemProps): {
  data: any,
  status: QueryStatus,
  setItem: (data: Item) => Promise<unknown>
} => {
  const queryClient = useQueryClient();
  const { status, data } = useQuery(['item', props.id], () => getItemById(props.id), {
    onSuccess: (response) => {
      if (props.id === '' || props.onSuccess === undefined) return;
      props.onSuccess(response);
    },
    enabled: props.id !== '' && props.id !== NIL,
    refetchOnWindowFocus: false,
  });

  const mutation = useMutation((newData: Item) => postItem(newData), {
    onSuccess: async (response, variables) => {
      await queryClient.invalidateQueries('items');
      await queryClient.invalidateQueries(['item', variables.id]);
    },
  });

  const setItem = (itemData: Item) => mutation.mutateAsync(itemData);

  if (props.id === NIL) {
    return {
      data: getEmptyItem(), setItem, status: 'success',
    };
  }
  return { data, setItem, status };
};

export default useItem;
